import { useState, useEffect } from 'react';
import { IConsultation } from '../types/Reservations/Reservations.type';
import { bookingService } from '../services/bookingService';
import { useAuthContext } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';

interface UseReservationsReturn {
  data: IConsultation[];
  loading: boolean;
  error: string | null;
}

export const useGetReservations = (): UseReservationsReturn => {
  const { user } = useAuthContext();
  const [data, setData] = useState<IConsultation[]>([]);
  const [loading, setLoading] = useState<boolean>(true); 
  const [error, setError] = useState<string | null>(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isPatientView = searchParams.get('view') === 'patient';
  const role: 'patient' | 'professional' = isPatientView ? 'patient' : (user?.type_account === 'professional' ? 'professional' : 'patient');

  useEffect(() => {
    const fetchReservations = async () => {
      try {
        setLoading(true); 
        const reservationsData = await bookingService.getBookings(role);
        setData(reservationsData);
        setError(null); 
      } catch (err: any) {
        console.error("Hook: Error al obtener datos.", err);
        setError(err.message || 'Ocurrió un error inesperado al cargar los datos.');
      } finally {
        setLoading(false);
      }
    };

    fetchReservations();
  }, [user?.uid, role]); 

  return { data, loading, error };
};